import { onFormError } from '../../core/utils/hooks'
import { notification } from 'antd'

import { useMutation } from '@tanstack/react-query'
import { updatePassword } from '../../api/common/user'

export const useChangePassword = () => {
  return useMutation({
    mutationFn: updatePassword,
    onSuccess: () => {
      notification.success({
        message: 'Updated',
        description: 'The password was updated.'
      })
    },
    onError: onFormError
  })
}
